import React, { ReactElement } from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';

export interface SignupStepFooterActionsThreeButtonsProps {
  back: ReactElement;
  skip: ReactElement;
  next: ReactElement;
}

export function SignupStepFooterActionsThreeButtons({
  back,
  skip,
  next,
}: SignupStepFooterActionsThreeButtonsProps): JSX.Element {
  return (
    <Flex width="100%" justifyContent="space-between" alignItems="center">
      <Flex>{back}</Flex>
      <Flex alignItems="center">
        <Stack x="x-sm">{skip}</Stack>
        {next}
      </Flex>
    </Flex>
  );
}
